import { User, user_response } from '../User';

export interface application_history_response {
    id: number;
    application_id: number;
    field: string;
    value: string;
    updated_by?: user_response;
    created_at?: string;
    updated_at?: string;
}

export class ApplicationHistory {
    public id: number = 0;
    public applicationId: number = 0;
    public field: string = '';
    public value: string = '';
    public updatedBy?: null | User;
    public createdAt?: Date;
    public updatedAt?: Date;

    public map(data: application_history_response) {
        this.id = data.id;
        this.applicationId = data.application_id;
        this.field = data.field;
        this.value = data.value;
        this.updatedBy = data.updated_by
            ? User.create(data.updated_by)
            : undefined;

        if (data.created_at) this.createdAt = new Date(data.created_at);
        if (data.updated_at) this.updatedAt = new Date(data.updated_at);

        return this;
    }

    public responsify(): application_history_response {
        return {
            id: this.id,
            application_id: this.applicationId,
            field: this.field,
            value: this.value,
            updated_by: this.updatedBy?.responsify(),
            created_at: this.createdAt?.toISOString(),
            updated_at: this.updatedAt?.toISOString(),
        };
    }

    public static create(data: application_history_response) {
        let r = new this();
        r.map(data);
        return r;
    }
}
